import { httpClient } from '@/api/http-client'
import { Borrower } from '@/types'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

type CreateBorrowerParams = {
  companyKey: string
  borrowerData: {
    tax_id: string
    tax_id_type: 'cpf' | 'cnpj'
    name: string
    email?: string
    phone?: string
    deal_id?: number
    customer_id?: number
    address?: {
      zip_code: string
      number: string
      complement?: string
      street: string
      district: string
      ibge_code: string | null
      state_code: string | null
    }
  }
}

export const createBorrower = async ({
  companyKey,
  borrowerData,
}: CreateBorrowerParams) => {
  const response = await httpClient('accounting-dealer').post<Borrower>(
    `/v3/company/${companyKey}/borrower`,
    borrowerData,
  )
  return response.data
}

export const useCreateBorrower = (
  options?: UseMutationOptions<Borrower, AxiosError, CreateBorrowerParams>,
) => {
  return useMutation({
    mutationFn: createBorrower,
    ...options,
  })
}
